import React, { Suspense } from 'react';
import { registerWorkspaceHostAuth } from '../../auth/registerWorkspaceHostAuth';

interface RemoteReviewBalanceDashboardProps {
  storageKey: string;
}

const ReviewBalanceRemote = React.lazy(async () => {
  const [module] = await Promise.all([
    // @ts-expect-error kciWorkspace is a Module Federation remote defined in vite.config.ts
    import('kciWorkspace/ReviewBalancePage'),
    registerWorkspaceHostAuth(),
  ]);
  const component =
    module.ReviewBalancePage ?? module.default?.ReviewBalancePage ?? module.default;

  if (!component) {
    throw new Error('ReviewBalancePage export not found in kciWorkspace/ReviewBalancePage');
  }

  return { default: component as React.ComponentType<{ storageKey: string }> };
});

export const RemoteReviewBalanceDashboard = React.memo(function RemoteReviewBalanceDashboard({
  storageKey,
}: RemoteReviewBalanceDashboardProps) {
  return (
    <Suspense fallback={<div className="body-content">Loading Review Balance…</div>}>
      <ReviewBalanceRemote storageKey={storageKey} />
    </Suspense>
  );
});

export default RemoteReviewBalanceDashboard;
